import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { INDRAApiService } from '@ibe.services/api.indra.service';
import { URL_RETRIEVE_PARAMS,
		MOCK_URL_PARAMS,
		MOCK_STATUS } from '@ibe.config';

@Injectable({
	providedIn: 'root'
})

export class ParamsIndraService {
	constructor(
		private http: HttpClient,
		private api: INDRAApiService
	) { }
	
	public getParamByName(paramName: String): Observable<any> {
		if (MOCK_STATUS.PARAMS) {
			return this.http.get<any>(MOCK_URL_PARAMS);
		} else {
			return this.api.INDRA_get<any>(`${URL_RETRIEVE_PARAMS}` + "/" + paramName);
		}
	}
}
